import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeSalaryLoan  {
    _originalTypeClassName = "zERP.BO.EmployeeSalaryLoan";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeSalaryLoan.translate = translateService;
}
this.Instalments = [];
this.Id = null;
this.ExternalLoanCode = null;
this.PrincipalAmount = null;
this.InstalmentsCount = null;
this.StartDate = null;
this.EndDate = null;
this.Comments = null;
this.Status = null;
this.CreatedOn = null;
this.ApprovedOn = null;
this.CanceldOn = null;
this.CancelReason = null;
this.RemainingAmount = null;
this.RemainingInstalments = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ExternalLoanCode:any;
PrincipalAmount:any;
InstalmentsCount:any;
StartDate:any;
EndDate:any;
Comments:any;
Status:any;
CreatedOn:any;
ApprovedOn:any;
CanceldOn:any;
CancelReason:any;
RemainingAmount:any;
RemainingInstalments:any;
Contract:any;
Type:any;
Instalments:any;
CreatedBy:any;
CanceledBy:any;
ApprovedBy:any;
static setContract = ($this, value) => {
var oldValue = $this.Contract;
$this.Contract = value;
if (value != null) {
}
}
static setType = ($this, value) => {
var oldValue = $this.Type;
$this.Type = value;
if (value != null) {
}
}
static setInstalments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Instalments == null) $this.Instalments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Instalments.length > 0) {
                    Domain.EmployeeSalaryLoan.removeInstalments($this, $this.Instalments[0]);
                }

                Domain.EmployeeSalaryLoan.addManyInstalments($this, copyItems);
            }
static addManyInstalments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeeSalaryLoan.addInstalments($this, items[i]);
                }
            }
static addInstalments = ($this, item) => {
                if ($this.Instalments == null) $this.Instalments = [];
                if (item == null || $this.Instalments.indexOf(item) > -1) return;
                $this.Instalments.push(item);
if (item.EmployeeSalaryLoan != $this) {
Domain.EmployeeSalaryLoanInstalment.setEmployeeSalaryLoan(item, $this);
}
}
static addRangeInstalments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeeSalaryLoan.addInstalments($this, item));
            }
static removeInstalments = ($this, item) => {
                if ($this == null || $this.Instalments == null || $this.Instalments.indexOf(item) === -1) return;
                var _index = $this.Instalments.indexOf(item);
                $this.Instalments.splice(_index, 1);
item.EmployeeSalaryLoan = null;
}
static clearInstalments = ($this) => { $this.Instalments = null; }
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setCanceledBy = ($this, value) => {
var oldValue = $this.CanceledBy;
$this.CanceledBy = value;
if (value != null) {
}
}
static setApprovedBy = ($this, value) => {
var oldValue = $this.ApprovedBy;
$this.ApprovedBy = value;
if (value != null) {
}
}

static CanBeCanceled($this: any): any{return $this?.Status == Domain.EmployeeSalaryLoanStatus.Approved && $this?.Instalments?.linq?.any((i) => i?.IsPaid);
}
static CanBeDeleted($this: any): any{return !(Domain.EmployeeSalaryLoan.IsNew($this)) && ($this?.Status == Domain.EmployeeSalaryLoanStatus.Pending || ($this?.Status == Domain.EmployeeSalaryLoanStatus.Approved && !($this?.Instalments?.linq?.any((i) => i?.IsPaid))));
}
static CanBeRevertedToDraft($this: any): any{return !(Domain.EmployeeSalaryLoan.IsNew($this)) && $this?.Status == Domain.EmployeeSalaryLoanStatus.Approved && !($this?.Instalments?.linq?.any((i) => i?.IsPaid));
}
static RecalculateFutureInstalments($this: any): any{let totalPaidAmount = $this?.Instalments?.linq?.where((i) => i?.IsPaid || i?.isCashPaid || i?.PayedOn != null)?.toArray()?.linq?.sum((i) => i?.Amount);
if ((CLMS.Framework.Number.GreaterThan(() => totalPaidAmount, () => $this.PrincipalAmount))) {return;}
let lastSettledInstalment = $this?.Instalments?.linq?.where((i) => i?.IsPaid || i?.isCashPaid || i?.PayedOn != null)?.toArray()?.linq?.orderByDescending((i) => i?.Index)?.toArray()?.linq?.where()?.firstOrDefault(null);
let lastFixedIndex = 0;
if ((lastSettledInstalment != null)) {lastFixedIndex = lastSettledInstalment?.Index;}
let instalmentsToAdjust = $this?.Instalments?.linq?.where((i) => CLMS.Framework.Number.GreaterThan(() => i.Index, () => lastFixedIndex) && !(i?.IsPaid) && !(i?.isCashPaid) && i?.PayedOn == null)?.toArray()?.linq?.orderBy((i) => i?.Index)?.toArray();
if ((CLMS.Framework.Number.Equal(() => instalmentsToAdjust.length, () => 0))) {return;}
let totalFixedAmount = $this?.Instalments?.linq?.where((i) => CLMS.Framework.Number.LessThanOrEqual(() => i.Index, () => lastFixedIndex))?.toArray()?.linq?.sum((i) => i?.Amount);
let remainingPrincipal = Joove.Common.safeNumber($this?.PrincipalAmount) - Joove.Common.safeNumber(totalFixedAmount);
let newInstalmentAmount = Joove.Common.safeNumber(remainingPrincipal) / Joove.Common.safeNumber(instalmentsToAdjust?.length);
let entityCurrencyAccuracy = Domain.BusinessEntity.GetCurrencyAccuracy($this?.Contract?.Entity);
newInstalmentAmount = Joove.Common.mathRound(newInstalmentAmount, entityCurrencyAccuracy);
for (let _iinst = 0; _iinst < (instalmentsToAdjust == null ? 0 : instalmentsToAdjust.length); _iinst++) {let inst = instalmentsToAdjust[_iinst];inst.Amount = newInstalmentAmount;}
let currentTotalSum = $this?.Instalments?.linq?.sum((i) => i?.Amount);
if ((CLMS.Framework.Number.NotEqual(() => currentTotalSum, () => $this.PrincipalAmount))) {let roundingDifference = Joove.Common.safeNumber($this?.PrincipalAmount) - Joove.Common.safeNumber(currentTotalSum);let lastInstalmentInList = $this?.Instalments?.linq?.orderBy((i) => i?.Index)?.toArray()?.linq?.lastOrDefault();lastInstalmentInList.Amount = Joove.Common.safeNumber(lastInstalmentInList?.Amount) + Joove.Common.safeNumber(roundingDifference);}
}
static UpdateRemainingData($this: any): any{$this.RemainingInstalments = Joove.Common.safeNumber($this?.InstalmentsCount) - Joove.Common.safeNumber($this?.Instalments?.linq?.count((i) => i?.IsPaid || i?.isCashPaid));
$this.RemainingAmount = Joove.Common.safeNumber($this?.PrincipalAmount) - Joove.Common.safeNumber($this?.Instalments?.linq?.where((i) => i?.IsPaid || i?.isCashPaid)?.toArray()?.linq?.sum((i) => i?.Amount));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}